import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");

  const getStatus = (status) => {
    if (status === 1) {
      return <Pending>Pending</Pending>;;
    }
     else if (status === 2) {
      return <Requested>Requested</Requested>;
    } else if(status === 3) {
      return <Occupied>Occupied</Occupied>;
    }
    else if(status === 4) {
      return  <Moving>Moving Out</Moving>;
    }
    else {
      return <Reserved>Reserved</Reserved>;
    }
  };

  const getId = (id) => {
    if (id) {
      return <Id>#{id}</Id>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };

  const getRent = (rent) => {
    if (rent > 0) {
      return <p>₹ {rent}</p>;
    } else {
      return <p>₹ 0</p>;
    }
  };

  const getGender = (tenantGender) => {
    if (tenantGender === 1) {
      return <p>Male</p>;
    } else if (tenantGender === 2) { 
      return <p>Female</p>;
    } else {
      return <p>Both</p>;
    }
  };
  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          <Status>{getId(selectedData?.id) || "N/A"}</Status>
          <Status className="ml-3">{getStatus(selectedData?.status) || "N/A"}</Status>
        </div>

        <Column>
          <FirstColumn>
            <SubHeading>Property Id</SubHeading>
            <Paragraph>{selectedData?.propId || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Tenant Id</SubHeading>
            <Paragraph>{selectedData?.tenantId || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Tenant Name</SubHeading>
            <Paragraph>{selectedData?.tenantName || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Owner Name</SubHeading>
            <Paragraph>{selectedData?.clientName || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>

          <TemplateButton
            ml
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
            Rent Details
          </TemplateButton>
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
              <SingleItem
                name="Property Name"
                value={(selectedData?.propertyName) || "N/A"}
              />
              <SingleItem
                name={"Room ID"}
                value={selectedData?.roomId || "N/A"}
              />
              <SingleItem
                name={"Room Number"}
                value={`${selectedData?.roomNum || "N/A"}`}
              />
              <SingleItem
                name="Gender"
                value={getGender(selectedData?.tenantGender || "N/A")}
              />
              <SingleItem
                name={"Created At"}
                value={selectedData?.createdAt ? new Date(selectedData.createdAt).toLocaleString() : "N/A"} 
              />
              <SingleItem
                name={"Move In Date"}
                value={selectedData?.moveInDate ? new Date(selectedData.moveInDate).toLocaleDateString() : "N/A"} 
              />
            </>
          )}

          {detailType === "2" && (
            <>
              <SingleItem
                name="Rent"
                value={getRent(selectedData?.rent || "0")}
              />
              <SingleItem
                name="Rental Cycle"
                value={selectedData?.rentalCycle || "N/A"}
              />
              <SingleItem
                name="Security"
                value={selectedData?.security || "N/A"}
              />
              <SingleItem
                name="Notice Period"
                value={selectedData?.noticePeriod || "N/A"}
              />
              <SingleItem
                name="Lock-In Period"
                value={selectedData?.lockinPeriod || "N/A"}
              />
              <SingleItem
                name="Agreement Period"
                value={selectedData?.agreementPeriod || "N/A"}
              />
              <SingleItem
                name={"Agreement Start Date"}
                value={selectedData?.agreementStartDate ? new Date(selectedData.agreementStartDate).toLocaleDateString() : "N/A"} 
              />              
            </>
          )}
        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <span>:</span>
    <Value>
      {(name === "Security" || name === "Fine" || name === "Maintenance Fee") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      {(name === "Agreement Period" ||
        name === "Notice Period" ||
        name === "Lock-In Period") && <span className="ml-1">months</span>}
      {name === "Grace Period" && <span className="ml-1">days</span>}
    </Value> 
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest}
    >
      {rest.children}
    </button>
  );
};
const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 `;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Name = tw.span`text-sm text-gray-500  w-32`;
const Value = tw.span`text-sm text-black font-medium w-80 px-6 `;
const Id = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Unverified = tw.div`border border-rose-600 text-rose-600 text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
const Requested = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-20 h-6 flex items-center justify-center rounded-full`;
const Occupied = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-20 h-6 flex items-center justify-center rounded-full`;
const Reserved = tw.div`bg-orange-100 text-orange-700 text-xs border-orange-300 border w-20 h-6 flex items-center justify-center rounded-full`;
const Moving = tw.div`bg-rose-100 text-rose-700 text-xs border-rose-300 border w-20 h-6 flex items-center justify-center rounded-full`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-20 h-6 flex items-center justify-center rounded`;

export default ViewDetailModel;


// import React from "react";
// import tw from "tailwind-styled-components";
// import { MdViewHeadline } from "react-icons/md";
// import Model from "../Model";

// const ViewDetailModel = ({ setViewDetail, selectedData }) => {
//   const getGender = (selectedData) => {
//     if (selectedData.gender == 1) {
//       return <>Male</>;
//     } else if (selectedData.gender == 2) {
//       return <>Female</>;
//     }
//   }; 

//   const getStatus = (status) => {
//     if (status === 1) {
//       return <Pending>Pending</Pending>;;
//     } else if (status === 2) {
//       return <Requested>Requested</Requested>;
//     } else if(status === 3) {
//       return <Occupied>Occupied</Occupied>;
//     }
//     else if(status === 4) {
//       return  <Moving>Moving Out</Moving>;
//     }
//     else {
//       return <Reserved>Reserved</Reserved>;
//     }
//   };


//   return (
// <Model width={`w-11/12 max-w-lg`} setOpenModel={setViewDetail}>
//   <Wrapper>
//   <Title><MdViewHeadline className="mt-1" />View Details</Title>
//   <SingleItem name={"Property ID"} value={selectedData?.propId || "N/A"} />
//   <SingleItem name={"Room ID"} value={selectedData?.roomId || "N/A"} />
//   <SingleItem name={"Tenant ID"} value={selectedData?.tenantId || "N/A"} />
//   <SingleItem name={"Owner Name"} value={selectedData?.clientName || "N/A"} />
//   <SingleItem name={"Tenant Name"} value={selectedData?.tenantName || "N/A"} />
//   <SingleItem name={"Floor/ Room"} value={`${selectedData?.floor || "N/A"}/${selectedData?.roomNum || "N/A"}`} />
//   {/* <SingleItem name={"Number of Beds"} value={selectedData?.bedCount || "N/A"} /> */}
//   <SingleItem name={"Rental Cycle"} value={selectedData?.rentalCycle || "N/A"} />
//   <SingleItem name={"Rent"} value={selectedData?.rent || "N/A"} />
//   <SingleItem name={"Security Deposit"} value={selectedData?.security || "N/A"} />
//   <SingleItem name={"Notice Period"} value={selectedData?.noticePeriod || "N/A"} />
//   <SingleItem name={"Lock-In Period"} value={selectedData?.lockInPeriod || "N/A"} /> 
//   <SingleItem name={"Agreement Period"} value={selectedData?.agreementPeriod || "N/A"} />
//   <SingleItem name={"Status"} value={getStatus(selectedData?.status) || "N/A"} />
//   <SingleItem name={"Agreement Start Date"} value={selectedData?.agreementStartDate ? new Date(selectedData.agreementStartDate).toLocaleDateString() : "N/A"} />
//   <SingleItem name={"Move In Date"} value={selectedData?.moveInDate ? new Date(selectedData.moveInDate).toLocaleDateString() : "N/A"} />
//   <SingleItem name={"Created At"} value={selectedData?.createdAt ? new Date(selectedData.createdAt).toLocaleString() : "N/A"} />
// </Wrapper>
// </Model> 
//   ); 
// };

// const SingleItem = ({ name, value }) => (
//   <div className="flex items-center py-2 border-b border-gray-100">
//     <Name>{name}</Name> <p>:</p>
//     <Value>
//       {(name === "Rent" || name === "Security Deposit" || name === "Maintenance Fee") && (value != 'N/A') && <span className="mr-1">₹</span>}
//       {value}
//       {(name === "Grace Period" || name === "Agreement Period" || name === "Notice Period" || name === "Lock-In Period") && (value != 'N/A') && <span className="ml-1">months</span>}
//     </Value> 
//   </div>
// );

// const Wrapper = tw.div`px-4`;
// const Title = tw.h2`flex flex-row gap-2 text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
// const Name = tw.p`text-sm text-gray-500  w-32`;
// const Value = tw.p`text-sm text-gray-800 font-medium w-80 px-6 `;
// const Requested = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Occupied= tw.div`bg-orange-100 text-orange-700 text-xs border-orange-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Reserved = tw.div`bg-red-100 text-red-700 text-xs border-red-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
// const Moving = tw.div`bg-lime-100 text-lime-700 text-xs border-lime-300 border w-24 h-7 flex items-center justify-center rounded`;

// export default ViewDetailModel;
